import type { TUIResourceImage } from '@/ducks/common/resources';
import type { TCurrencyCode, TImage } from '@/infra/types/common';
import type { TFetchPartsOptions } from '@/store/fetchableParts/types';

import { fetchImage } from '@/features/api/endpoints/common';
import {
  fetchQuickSearchItems,
  QUICK_SEARCH_ITEMS_RESOURCES,
  type TFetchQuickSearchItemsArgs,
} from '@/features/promo/QuickSearchCards/model/actions';
import { type QuickSearchItemsData } from '@/features/promo/QuickSearchCards/model/types';
import { createQuickSearchItemsRecord } from '@/features/promo/QuickSearchCards/model/utils';

export const QUICK_SEARCH_RESOURCES = ['Promotion.headerBackground', ...QUICK_SEARCH_ITEMS_RESOURCES] as const;

export type TFetchQuickSearchArgs = Omit<TFetchQuickSearchItemsArgs, 'apolloClient' | 'resources'> & {
  currencyCode: TCurrencyCode;
  fetchOptions?: TFetchPartsOptions;
  resources: TFetchQuickSearchItemsArgs['resources'] & { 'Promotion.headerBackground': TImage };
  sailors: number;
};

export const fetchQuickSearchItemsData = async (args: TFetchQuickSearchArgs): Promise<QuickSearchItemsData> => {
  const { currencyCode = 'USD', fetchOptions, onResponseHeaders, resources, sailors = 2 } = args || {};
  // TODO: replace naming from CMS side
  const backgroundImageSrc = (resources?.['Promotion.headerBackground'] as TUIResourceImage)?.src;
  const [headlineBackground, items] = await Promise.all([
    backgroundImageSrc
      ? fetchImage(backgroundImageSrc, fetchOptions).catch(() => undefined)
      : Promise.resolve(undefined),
    fetchQuickSearchItems({ currencyCode, fetchOptions, onResponseHeaders, resources, sailors }),
  ]);
  return { headlineBackground, items: createQuickSearchItemsRecord(items, currencyCode, sailors) };
};
